// @flow
import ko from 'rgs-knockout';
import {components} from './definitions';

const createModel = (name: string): any => {
	const {viewModel: ViewModel, template} = components[name];

	return {
		viewModel: {
			createViewModel: (...args) => new ViewModel(...args),
		},
		template: template(),
	};
};

//PAY ATTENTION! COMPONENT NAME BEGINNING AT 'nfd-' +NAME
const registerComponent = (name: string): void => {
	ko.components.register(`nfd-${name}`, createModel(name));
};

export default (...args: Array<*>) => args.forEach(registerComponent);


